import { Component, OnInit, AfterViewInit } from "@angular/core";
import { CclMessageService } from "certain-common-library";
import { SharedService } from "../../modules/shared/services/shared.service";

@Component({
  selector: "app-attendeen-feature",
  templateUrl: "./attendee-feature.view.html",
  styleUrls: [],
  providers: []
})
export class AttendeeFeatureView implements OnInit, AfterViewInit {

  constructor(
    public sharedService: SharedService,
    private messageService: CclMessageService
  ) {
    
  }
  ngAfterViewInit() {}

  ngOnInit(): void {}

  publishCatalog() {
    this.messageService.sendMessage("publish-catalog");
  }
  launchPublishedCatalog() {
    this.messageService.sendMessage("launch-published-catalog");
  }
}
